import { Header } from '../components/Header';
import css from './index.module.scss';
import Step1H5 from './components/Step1';
import Step2H5 from './components/Step2';
import Step3H5 from './components/Step3';
import Step456H5 from './components/Step456';
import Step7H5 from './components/Step7';
import Crum from '@/components/Crum';
import { useGlobal } from '@/utils/useGlobal';
import { Mm100Page } from '@/components/calculators/power-kits';

export default function Mm100CalculatorH5() {
    const { useState, useLang, useRouter, useEffect } = useGlobal();
    const { t } = useLang('shared');
    const router = useRouter();
    const { locale } = router;
    const stepTitle = ['scenery', 'type', 'appliances', 'power_hub', 'combo', 'solar_panel', 'result'];
    const [calcObj, setCalcObj] = useState({
        currentStep: 1,
        totalStep: 7,
        stepTitle,
        currentPage: Mm100Page.Scenery,
    });

    const breadcrumbData = [
        { name: t('calculators.mm100.crum_home'), link: '/' },
        { name: t('calculators.mm100.crum_mm100'), link: '/ecoflow-power-kits/series' },
        { name: t('calculators.mm100.crum_calculator') },
    ];

    useEffect(() => {
        if (sessionStorage) {
            const session = sessionStorage.getItem(`calculatorMM100_${locale}`);
            if (session) {
                setCalcObj(JSON.parse(session));
            }
        }
    }, []);

    useEffect(() => {
        if (window) {
            window.addEventListener('beforeunload', beforeunload);
        }
        return () => window.removeEventListener('beforeunload', beforeunload);
    }, [calcObj]);

    const beforeunload = () => {
        sessionStorage.setItem(`calculatorMM100_${locale}`, JSON.stringify(calcObj));
    };

    const updateCalcObj = (obj: any, again = false) => {
        if (again) {
            sessionStorage.removeItem('calculatorMM100');
            setCalcObj({ currentStep: 1, totalStep: 7, stepTitle, currentPage: Mm100Page.Scenery });
        } else {
            setCalcObj({ ...calcObj, ...obj });
        }
    };

    useEffect(() => {
        if (calcObj?.currentPage !== Mm100Page.SolarPanel) {
            window.scrollTo(0, 0);
        }
    }, [calcObj?.currentPage]);

    return (
        <div className={`calculatorMm100H5 ${css.calculatorMm100H5}`}>
            <h1 className="visuallyhidden">EcoFlow Calculator</h1>
            <Crum data={breadcrumbData} />
            <div
                className={`calculatorMm100H5-container ${
                    [Mm100Page.PowerKits, Mm100Page.Combo, Mm100Page.SolarPanel, Mm100Page.Result].includes(calcObj.currentPage) ? 'special' : ''
                }`}
            >
                <div className="calculatorMm100-commonHeader">
                    <Header calcObj={calcObj} />
                </div>
                <div className="calculatorMm100-stepComponents">
                    {calcObj.currentPage === Mm100Page.Scenery && <Step1H5 data={calcObj} callBack={updateCalcObj} />}
                    {calcObj.currentPage === Mm100Page.Type && <Step2H5 data={calcObj} callBack={updateCalcObj} />}
                    {calcObj.currentPage === Mm100Page.Appliances && <Step3H5 data={calcObj} callBack={updateCalcObj} />}
                    {[Mm100Page.PowerKits, Mm100Page.Combo, Mm100Page.SolarPanel].includes(calcObj.currentPage) && (
                        <Step456H5 data={calcObj} callBack={updateCalcObj} />
                    )}
                    {calcObj.currentPage === Mm100Page.Result && <Step7H5 data={calcObj} callBack={updateCalcObj} />}
                </div>
            </div>
        </div>
    );
}
